import { render, staticRenderFns } from "./InvestmentValuationsSection.vue?vue&type=template&id=6b2551d1&"
import script from "./InvestmentValuationsSection.vue?vue&type=script&lang=ts&"
export * from "./InvestmentValuationsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports